const IconMail = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M1.06648 0C0.741951 0 0.466797 0.275261 0.466797 0.599678V8.39619C0.466797 8.72061 0.742058 8.99587 1.06648 8.99587H13.6608C13.9854 8.99587 14.2605 8.72061 14.2605 8.39619V0.599678C14.2605 0.275154 13.9853 0 13.6608 0H1.06648ZM2.08326 0.899651H12.6442L7.36358 5.54757L2.08299 0.899651H2.08326ZM1.36645 1.4619L7.06872 6.48465H7.06861C7.1504 6.55577 7.2553 6.59499 7.36374 6.59499C7.47218 6.59499 7.5771 6.55577 7.65887 6.48465L13.3611 1.4619V8.09643H1.3665V1.4619H1.36645Z"
            fill={color}
        />
    </svg>
);

export default IconMail;
